import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router'

import { LoadingIndicator } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/LoadingIndicator'

import Dashboard from './Dashboard'
import { useNewDashboard } from './hooks/useNewDashboard'
import { LT_CLIENTS } from '../common/constants/routingConstants'
import { getAppIsLdInitialized } from '../data/appSelectors'
import { getAuthConfig } from '../data/auth/authSelectors'
import BCDashboard from '../lyraTherapy/bcDashboard/BCDashboard'

const DashboardContainer: React.FC = () => {
  const config = useSelector(getAuthConfig)
  const isLdInitialized = useSelector(getAppIsLdInitialized)
  const showNewDashboard = useNewDashboard()

  if (config?.hideTodoPage) {
    if (!isLdInitialized) {
      return <LoadingIndicator />
    }
    if (!showNewDashboard) {
      return <Navigate to={LT_CLIENTS.route} />
    }
    return <Dashboard />
  }
  return <BCDashboard />
}

export default DashboardContainer
